"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (a, b) => a.week > b.week ? 1 : -1;
//# sourceMappingURL=weekSort.js.map